module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "manual-scan-container"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "manual-input-section"
  }, [_c('div', {
    staticClass: "input-container"
  }, [_c('div', {
    staticClass: "input-wrapper"
  }, [_c('i', {
    staticClass: "fa fa-keyboard-o input-icon"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.passCode),
      expression: "formData.passCode"
    }],
    staticClass: "passcode-input",
    attrs: {
      "id": "passCode",
      "type": "text",
      "placeholder": "Ketik ID Reservasi Manual"
    },
    domProps: {
      "value": (_vm.formData.passCode)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.onEnterPassCode($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "passCode", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-hint"
  }, [_vm._v("Tekan Enter atau klik tombol untuk submit")])])]), _vm._v(" "), _c('div', {
    staticClass: "scanner-section"
  }, [_c('div', {
    staticClass: "scanner-card"
  }, [(!_vm.isScannerEnabled || _vm.cameraError) ? _c('div', {
    staticClass: "camera-inactive"
  }, [_c('i', {
    staticClass: "fa fa-camera camera-icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "camera-title"
  }, [_vm._v("Kamera Tidak Aktif")]), _vm._v(" "), _c('div', {
    staticClass: "camera-desc"
  }, [_vm._v("Klik tombol \"Mulai Scan\" untuk mengaktifkan kamera")])]) : _c('div', [_c('div', {
    staticClass: "scanner-title"
  }, [_vm._v("QR Code Scanner")]), _vm._v(" "), _c('div', {
    staticClass: "scanner-desc"
  }, [_vm._v("Scan Tiket Qr untuk mencatat kehadiran")]), _vm._v(" "), (_vm.isScannerEnabled && !_vm.cameraError) ? _c('StreamBarcodeReader', {
    on: {
      "decode": _vm.onDecode,
      "loaded": _vm.onLoaded,
      "error": _vm.onScanError
    }
  }) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "btn-scan-qr"
  }, [_c('button', {
    staticClass: "scan-btn",
    on: {
      "click": _vm.toggleScanner
    }
  }, [_c('i', {
    staticClass: "fa fa-play"
  }), _vm._v(" Mulai Scan\n    ")])]), _vm._v(" "), (_vm.messageType) ? _c('div', {
    staticClass: "modal-overlay",
    on: {
      "click": _vm.closeBanner
    }
  }, [_c('div', {
    staticClass: "modal-alert",
    class: {
      'modal-success': _vm.messageType === 'SUCCESS',
      'modal-error': _vm.messageType === 'ERROR'
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('div', {
    staticClass: "modal-icon"
  }, [(_vm.messageType === 'SUCCESS') ? _c('i', {
    staticClass: "fa fa-check-circle"
  }) : _vm._e(), _vm._v(" "), (_vm.messageType === 'ERROR') ? _c('i', {
    staticClass: "fa fa-exclamation-circle"
  }) : _vm._e()]), _vm._v(" "), _c('button', {
    staticClass: "modal-close",
    on: {
      "click": _vm.closeBanner
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('h3', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.messageType === 'SUCCESS' ? 'Berhasil!' : 'Terjadi Kesalahan'))]), _vm._v(" "), _c('div', {
    staticClass: "modal-message",
    domProps: {
      "innerHTML": _vm._s(_vm.messageText)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "modal-btn",
    on: {
      "click": _vm.closeBanner
    }
  }, [_vm._v("OK")]), _vm._v(" "), _c('button', {
    staticClass: "modal-btn",
    on: {
      "click": _vm.toggleScanner
    }
  }, [_vm._v("Scan Again")])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": "/static/img/logo_blk.png",
      "alt": "e-MemberS Logo"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "header-title"
  }, [_c('span', {
    staticClass: "brand"
  }, [_vm._v("e-MemberS")]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v("Qr Scanner for Check in/Out")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-box"
  }, [_c('div', {
    staticClass: "info-title"
  }, [_c('span', {
    staticClass: "icon-qr"
  }, [_vm._v("📷")]), _vm._v(" "), _c('b', [_vm._v("Scan Digital Member Card")])]), _vm._v(" "), _c('ul', {
    staticClass: "info-list"
  }, [_c('li', [_vm._v("Arahkan kamera ke QR Code pada digital member card")]), _vm._v(" "), _c('li', [_vm._v("Sistem akan otomatis memvalidasi tiket sesuai jadwal")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-da4d400c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/ManualScanCheckInOut.vue
// module id = 779
// module chunks = 1